module.exports = __webpack_public_path__ + "img/Feature.a1bbc520.png";